import mitt from 'mitt';

export const context = { home: 'home' };
export const actions = {
  showEmailCollectDialog: 'showEmailCollectDialog',
  showMailOrderDialog: 'showMailOrderDialog',
  loadedActivityDialog: 'loadedActivityDialog',

  lightningReload: 'lightningReload',

  updateCollectionDealId: 'updateCollectionDealId',
  showFaqActiveKey: 'showFaqActiveKey',
  showLoginSignuPopup: 'showLoginSignuPopup',
  showTermsOfServicePopUp: 'showTermsOfServicePopUp',
  showPrivacyPolicyPopUp: 'showPrivacyPolicyPopUp',
  showForgetPasswordPopUp: 'showForgetPasswordPopUp',
  showPhoneConnectPopUp: 'showPhoneConnectPopUp',
  showBindConnetPopUp: 'showBindConnetPopUp',

  /** Add On Session 页面获取数据时触发 */
  refreshAddOnSessionProducts: 'refreshAddOnSessionProducts',

  /** 关闭mkpl mini cart */
  hideMkplMiniCart: 'hideMkplMiniCart',

  /** GlobalNavHeader: category page has L1 links (categories) on server render.
   * Home page, on the other hand, loads it async depending on API response.
   * Global+ pages do not load the same concept at all and need a fallback approach to have it loaded ASYNC or
   * re-used from in-memory cache from having visited pages like home or categories, etc.
   * Each page may or may not load links that are compatible with the GlobalNavHeader UX intent
   * but they should all be able to show the final UI*/
  loadedGlobalNavHeaderCompatibleLinks: 'loadedGlobalNavHeaderCompatibleLinks',

  /** globalNavHeaderOnClickCategory: to avoid complex data delegation or callback hell, navbar will emit clicked categories
   * if the current page is anything other than /category/[...slug], the <Link/> component is capable of navigating to category page.
   * If the current page is /category/[...slug], then the pages that obey to GlobalNavHeader category sliders have to listen to this event.
   * and perform data fetch, followed by page content update.
   */
  globalNavHeaderOnClickCategory: 'globalNavHeaderOnClickCategory',

  blockRoutePushScrollRestoration: 'blockRoutePushScrollRestoration',

  /**
   * 分类页菜单点击事件
   * 分类页菜单点击后，发送改事件，吸顶菜单监听此事件，更新选中的一级菜单
   *
   * GlobalNavHeader组件会监听此事件，实时更新吸顶菜单选中状态
   */
  categoryItemOnClickCategory: 'categoryItemOnClickCategory',
  // 激活优惠券
  activateCoupon: 'activateCoupon'
};

export enum sectionType {
  mainBanner = 'mainBanner'
}

export const Noop = () => {
  return void 0;
};

export default mitt();
